const splitDate = (dateValue) => {
  const [year, month, day] = String(dateValue || "").split("-");

  if (!year || !month || !day) {
    return null;
  }

  return { year, month, day };
};

export const formatDateSlash = (dateValue) => {
  const parts = splitDate(dateValue);
  return parts ? `${parts.day}/${parts.month}/${parts.year}` : "";
};

export const formatDateDot = (dateValue) => {
  const parts = splitDate(dateValue);
  return parts ? `${parts.day}.${parts.month}.${parts.year}` : "";
};

export const formatPrintedTime = (timeValue) => {
  if (!timeValue) {
    return "";
  }

  return `${timeValue.replace(":", "")}HRS`;
};

export const formatPrintTimestamp = (isoValue) => {
  if (!isoValue) {
    return "";
  }

  const date = new Date(isoValue);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  return `${day}.${month}.${year} TIME:${hour}${minute}HRS`;
};
